// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9e1be420","488":"62c712a0","796":"33a7488c"}[chunkId] + ".chunk.js";
};